function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.289014 6.14155H2.31211V10.6454C2.31211 10.8043 2.43013 10.9344 2.58908 10.9344H4.51585C4.6748 10.9344 4.8169 10.8043 4.8169 10.6454V6.14155H7.91176C7.98883 6.14155 8.06108 6.11024 8.11407 6.05484L10.1733 4.02452C10.2287 3.96913 10.26 3.89446 10.26 3.81739C10.26 3.74032 10.2287 3.66566 10.1733 3.61027L8.11407 1.60162C8.06108 1.54863 7.98883 1.51492 7.91176 1.51492H4.8169V0.289014C4.8169 0.130056 4.67721 0 4.51585 0H2.58908C2.43013 0 2.31211 0.130056 2.31211 0.289014V1.51732H0.289014C0.130056 1.51732 0 1.65701 0 1.81838V5.84772C0 6.00668 0.130056 6.14155 0.289014 6.14155ZM4.23887 10.3563H2.89014V6.14155H4.23887V10.3563ZM2.89014 0.578028H4.23887V1.51732H2.89014V0.578028ZM0.578028 2.09535H7.79375L9.55673 3.81739L7.79375 5.56352H0.578028V2.09535Z",
  fill: "#777777"
});

var SvgAddressIcon = function SvgAddressIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddressIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address-icon.2cea5eb1.svg";
export { ForwardRef as ReactComponent };